const Templates = {};

Templates.KontentItemImage = require("./kontentItemImage").default;
Templates.KontentItemCtaButton = require("./kontentItemCtaButton").default;

export default Templates;
